import { FilterSearchBox } from "@octopusdeploy/design-system-octopus-components";
import type { MachineTenantSummaryResource, TenantResource } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import { useState } from "react";
import type { OctopusTheme } from "~/components/Theme";
import { useOctopusTheme } from "~/components/Theme";
import { ResultsLink } from "../ResultsLink";
import styles from "../style.module.less";
import { TenantContentRow } from "./TenantsContentRow";
interface TenantsContentWithThemeProps {
    spaceId: string;
    tenantSummaries: MachineTenantSummaryResource;
    tenantsResource: TenantResource[];
    numberOfItemsToRender: number;
    theme: OctopusTheme;
}
const onFilter = (filter: string, resource: TenantResource) => {
    return !filter || filter.length === 0 || !resource || resource.Name.toLowerCase().includes(filter.toLowerCase());
};
const TenantsContentWithTheme = ({ spaceId, tenantsResource, tenantSummaries, theme, numberOfItemsToRender }: TenantsContentWithThemeProps) => {
    const [filterText, setFilterText] = useState("");
    const filteredTenants = tenantsResource.filter((item) => onFilter(filterText, item)).slice(0, numberOfItemsToRender);
    // Show enabled tenants first
    filteredTenants.sort((a, b) => Number(!!a.IsDisabled) - Number(!!b.IsDisabled));
    return (<>
            {(tenantsResource.length > 1 || filterText) && (<FilterSearchBox placeholder="Filter..." onChange={(value) => setFilterText(value.toLowerCase())} containerClassName={styles.cardContentContainerFilter} inputClassName={styles.dashboardFilterInputClassName} iconColor={theme.secondaryText}/>)}
            <div className={styles.cardContentContainerRows}>
                {filteredTenants.map((tenant: TenantResource) => {
            return <TenantContentRow key={tenant.Name} tenant={tenant} tenantSummaries={tenantSummaries}/>;
        })}
                {<ResultsLink totalCount={tenantsResource.length} renderedCount={filteredTenants.length} link={links.tenantsPage.generateUrl({ spaceId })}/>}
            </div>
        </>);
};
interface TenantsContentProps {
    spaceId: string;
    tenantSummaries: MachineTenantSummaryResource | undefined;
    tenantsResource: TenantResource[];
    numberOfItemsToRender: number;
}
export const TenantsContent = ({ spaceId, tenantSummaries, tenantsResource, numberOfItemsToRender }: TenantsContentProps) => {
    const theme = useOctopusTheme();
    return tenantSummaries !== undefined ? <TenantsContentWithTheme spaceId={spaceId} tenantSummaries={tenantSummaries} tenantsResource={tenantsResource} numberOfItemsToRender={numberOfItemsToRender} theme={theme}/> : null;
};
